<div class="litmus-button-container">
    <button [class]="class_name" (click)="onClick($event)" [disabled]="disabled" [innerHtml]="text"></button>
</div>